// extracted by mini-css-extract-plugin
export var animating = "_2x-3";
export var background = "_2x-6";
export var constrainHeight = "_2x-2";
export var dark = "_2x-4";
export var dropdown = "_2x-1";
export var leave = "_2x-5";
export var option = "_2x-7";
export var root = "_2x-0";